import { useEffect, useState } from "react";

import { fetchConsultSession } from "../../api/healthcare/Consultation/ConsultApi";

interface UseConsultSessionOptions {
	appointmentId: number;
	enabled: boolean;
}

interface UseConsultSessionResult {
	consultSessionId: number | null;
	loadingGuidance: boolean;
}

export function useConsultSession({ appointmentId, enabled }: UseConsultSessionOptions): UseConsultSessionResult {
	const [consultSessionId, setConsultSessionId] = useState<number | null>(null);
	const [loadingGuidance, setLoadingGuidance] = useState(false);

	useEffect(() => {
		const tryLoadSession = async () => {
			if (!appointmentId || !enabled) return;
			setLoadingGuidance(true);
			try {
				const res = await fetchConsultSession(appointmentId);
				if (res?.session?.id) setConsultSessionId(res.session.id);
			} catch {
				// No session yet
			} finally {
				setLoadingGuidance(false);
			}
		};
		tryLoadSession();
	}, [appointmentId, enabled]);

	return { consultSessionId, loadingGuidance };
}
